import { render, staticRenderFns } from "./ChartRecebidasPorCanal.vue?vue&type=template&id=da8ef8b6&"
import script from "./ChartRecebidasPorCanal.vue?vue&type=script&lang=js&"
export * from "./ChartRecebidasPorCanal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports